/**
 * inAppBrowser.js
 *
 * Detects when the app is running inside an app's built-in browser (an embedded
 * WebView) rather than a real browser like Chrome/Safari. In-app browsers (WhatsApp,
 * Cliq, Instagram, Facebook, etc.) use an isolated cookie jar, and Zoho Embedded Auth's
 * OAuth handshake hops across that boundary — so the session cookie set in one context
 * isn't visible in the other, and sign-in loops. Larynx links arrive via WhatsApp, Cliq
 * notifications, and QR scanners, so this is a common entry path.
 *
 * Conservative by design: matches only well-known in-app markers + Android System
 * WebView, so it won't false-positive on real Chrome/Safari (we only *warn*, never block).
 */
export function isInAppBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';

  // Known in-app browser / embedded-WebView host markers.
  const markers = [
    'FBAN', 'FBAV', 'FB_IAB',   // Facebook
    'Instagram',
    'WhatsApp',
    'Line/',
    'MicroMessenger',           // WeChat
    'Snapchat',
    'LinkedInApp',
    'Cliq', 'ZohoCliq',         // Zoho Cliq (we send notifications through it)
    'GSA/',                     // Google Search app
  ];
  if (markers.some((m) => ua.includes(m))) return true;

  // Android System WebView — the engine most in-app browsers embed. Real Chrome on
  // Android does NOT carry the "; wv)" token.
  if (/;\s*wv\)/.test(ua)) return true;

  return false;
}
